import React, { Fragment, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import MakeAPICall from "../../apiCalls/common";
import { getCouponDetailsApiRoute } from "../../apiRoutes";
import appRoutes from "../../routes/appRoutes";
import { getFormattedDate, getFormattedMoney } from "../../utils/dateTimeHelper";
import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import { CSVLink } from "react-csv";
import Button from "../../components/button";
import moment from "moment";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { BRAND_DISPLAY_NAMES } from "../../constants/helperConstants";

const CouponDetailsPage = props => {
  const { id } = useParams();
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [data, setData] = useState(null);
  const [modalText, setModalText] = useState("");
  const [showTextModal, setShowTextModal] = useState(false);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [excelSheetHeader, setExcelSheetHeader] = useState([]);
  const [CVSTitle, setCVSTitle] = useState("Coupon");
  const [totalUsedCount, setTotalUsedCount] = useState(0);
  const [showExportModal, setShowExportModal] = useState(false);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [filteredData, setFilteredData] = useState([]);

  const getDetails = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getCouponDetailsApiRoute,
      params: {
        couponId: id
      },
      successCallback: res => {
        if (res.data.data && res.data.data.length > 0) {
          setData(res.data.data[0]);
        }

        // fail safe
        const data = res.data && res.data.data && res.data.data[0] ? res.data.data[0] : [];
        const CSVData = [];
        let totalCount = 0;

        data.appliedBy.map((obj, index) => {
          if (obj.patientId && obj.redeemedDate) {
            totalCount++;
          }
          const tempObj = {};

          tempObj["Date Coupon Created"] = getFormattedDate(data.createdAt);
          tempObj["Date Coupon Expired"] = getFormattedDate(data.expiryDate);
          tempObj["Date Coupon Added"] = getFormattedDate(obj.addedAt);
          tempObj["Date Coupon Used"] = obj.redeemedDate ? getFormattedDate(obj.redeemedDate) : "-";
          tempObj["Consult Type Used"] = BRAND_DISPLAY_NAMES[obj.appliedCouponType] || obj.appliedCouponType
          tempObj["Patient UIN"] = obj.patientId && obj.patientId.patientId ? obj.patientId.patientId : "Patient Deleted";
          tempObj["Patient Name"] = getName(obj);
          tempObj["Patient Email"] = obj.patientId && obj.patientId.email ? obj.patientId.email : "-";
          tempObj["Value of Coupon"] = data.isPercent ? data.amount + "%" : getFormattedMoney(data.amount);
          CSVData.push(tempObj);
        });

        setCVSTitle("Coupon Export - " + data.code);
        setExcelSheetData(CSVData);
        setTotalUsedCount(totalCount);
        setExcelSheetHeader([
          "Date Coupon Created",
          "Date Coupon Expired",
          "Date Coupon Added",
          "Date Coupon Used",
          "Consult Type Used",
          "Patient UIN",
          "Patient Name",
          "Patient Email",
          "Value of Coupon"
        ]);

        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        //setShowTextModal(true);
      }
    });
  };

  function filterDataForCSV() {
    if (startDate && endDate) {
      const filteredData = excelSheetData.filter((obj) => {
        return moment(obj.addedAt).isBetween(
          startDate.startOf("day"),
          endDate.endOf("day"),
          null, "[]");
      });

      console.log("Filtered Data: ", filteredData);

      setFilteredData(filteredData);
    }
  }

  useEffect(filterDataForCSV, [startDate, endDate]);

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      filteredData.length = 0;
    };
  }, []);

  function getName(pat) {
    let patientName = "";

    if (pat && pat.patientId && pat.patientId.firstName) {
      patientName = pat.patientId.firstName.trim();

      if (pat.patientId.middleName.trim() !== "") {
        patientName =
          patientName +
          " " +
          pat.patientId.middleName.trim();
      }

      patientName =
        patientName + " " + pat.patientId.lastName.trim();
    }

    return patientName;
  }

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="view-ticket-container">
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showTextModal}
            cancelEvent={() => {
              setShowTextModal(false);
              setModalText("");
            }}
            modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
          />
          <NavLink
            to={{
              pathname: appRoutes.viewCouponsList,
              state: {
                currPageNo:
                  props.location.state && props.location.state.currPageNo
                    ? props.location.state.currPageNo
                    : null
              }
            }}
            className="details-back-link"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 back-btn-text"> Back to Coupons</span>
          </NavLink>
          <div className="d-flex flex-row justify-content-between mt-4">
            <h3>Coupon Details</h3>
            <Button title="Export to CSV" onClick={() => {
              filterDataForCSV();
              setShowExportModal(true);
            }} />
          </div>
          <br />
          {data !== null && (
            <div className="consult-details-container">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <b>Coupon:</b> <span>{data.code}</span>
                  </p>
                  <p>
                    <b>Applicable: </b>
                    <span>
                      {data.couponTypes && data.couponTypes.length > 0
                        ? data.couponTypes
                          .map(type => BRAND_DISPLAY_NAMES[type] || type)
                          .join(", ")
                        : ""}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Date Created:</b>{" "}
                    <span>{getFormattedDate(data.createdAt)}</span>
                  </p>
                  <p>
                    <b>Expiry Date:</b>{" "}
                    <span>{getFormattedDate(data.expiryDate)}</span>
                  </p>
                </div>
                <div className="col-md-12">
                  <hr />
                </div>
                <div className="col-md-6">
                  <p>
                    <b>One Time Use:</b>{" "}
                    <span>
                      {data.oneTimeUse === true ? "Yes" : "No"}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <b>Status:</b>{" "}
                    <span>
                      {data.isActive === true ? "Active" : "Disabled"}
                    </span>
                  </p>
                </div>
                {
                  data.appliedBy && (
                    <div className="col-md-6">
                      <p>
                        <b>Applied:</b>{" "}
                        <span>
                          {data.appliedBy.length}
                        </span>
                      </p>
                    </div>
                  )
                }
                <div className="col-md-6">
                  <p>
                    <b>Redeemed:</b>{" "}
                    <span>
                      {totalUsedCount}
                    </span>
                  </p>
                </div>


                <div className="col-md-12">
                  <hr />
                </div>
                {data.appliedBy.length === 0 && (
                  <div className="col-md-12">
                    <p className="mb-2">
                      <span>Not Redeemed Yet</span>
                    </p>
                  </div>
                )}

                {data.appliedBy.length > 0 && (
                  <div className="col-md-12">
                    <p className="mb-2">
                      <b>Patients:</b>
                    </p>
                    <p>
                      <span>
                        {data.appliedBy.map((pat, index) => {
                          let patientName = getName(pat);
                          let seq = index + 1;
                          let appoint = "";

                          if (pat.appointments) {
                            appoint =
                              " (Consult ID: " +
                              pat.appointments.appointmentId +
                              ")";
                          }

                          return (
                            <Fragment key={index}>
                              {seq}. {pat.patientId && pat.patientId.patientId ? "UIN: " + pat.patientId.patientId + " | " : ""} {" "}
                              {!pat.patientId ? "Patient Deleted" : ""}
                              {patientName}
                              {appoint}
                              <br />
                            </Fragment>
                          );
                        })}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          <br />
          <br />
        </div>
      </div>
      <CustomModal
        title="Export to CSV"
        noFooterButtons={true}
        cancelText="Export"
        openModal={showExportModal}
        cancelEvent={() => {
          setShowExportModal(false);
        }}
        modalBodyContent={<div className="row text-center">
          <div className="row px-4 w-100 mx-auto">
            <KeyboardDatePicker
              name="startDate"
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="From"
              value={startDate}
              onChange={setStartDate}
            />
            <div style={{ width: "8px" }} />
            <KeyboardDatePicker
              name="endDate"
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="To"
              value={endDate}
              onChange={setEndDate}
            />
          </div>

          <div className="row mx-auto mt-4">
            <CSVLink
              className="no-text-decoration mr-4"
              filename={`${CVSTitle || "Coupon CSV"}.csv`}
              data={filteredData}
              headers={excelSheetHeader}>
              <Button title="Export to CSV" onClick={() => setShowExportModal(false)} />
            </CSVLink>
            <Button title="Cancel" onClick={() => setShowExportModal(false)} />
          </div>
        </div>}
      />
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </Fragment>
  );
};

export default CouponDetailsPage;
